import React, { useState } from 'react'
import { useAuthContext } from 'contexts/Auth';
import { Layout, Menu } from 'antd';
import Header from "components/dashboard/Header"
import Routes from "./Routes"
import { items } from "./SidebarItems"
import Footer from 'components/dashboard/Footer/Footer';

const { Content, Sider } = Layout;

export default function Dashboard() {

    const { user } = useAuthContext()
    const [collpased, setCollapsed] = useState(false)

    return (
        <Layout>
            <Header />
            <Layout hasSider>
                <Sider breakpoint='lg' collapsible collapsed={collpased} collapsedWidth="80px" width="240px" className='custom-sider position-fixed vh-100'
                    onCollapse={(collapsed) => {
                        setCollapsed(collapsed);
                    }}
                    style={{ maxHeight: 'calc(100vh - 100px)', overflow: 'auto' }}
                >
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={['4']}
                        items={items.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
                    />
                </Sider>

                <Content className='p-3 pb-0' style={{ marginLeft: collpased ? 80 : 240, transition: "all 0.2s" }}>
                    <Routes />
                    <Footer />
                </Content>
            </Layout>
        </Layout>
    )
}
